var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Editor',{ref:"editor",attrs:{"initialValue":_vm.contents,"options":_vm.editorOptions,"height":"400px","initialEditType":"wysiwyg","previewStyle":"vertical"}})
}
var staticRenderFns = []

export { render, staticRenderFns }